export default [
  {
    path: '/403',
    name: '403',
    meta: {
      label: '403',
      hidden: true,
    },
    component: loadView('views/error/403'),
  },
  {
    path: '*',
    name: '404',
    meta: {
      label: '404',
      hidden: true,
    },
    component: loadView('views/error/404'),
  },
  {
    path: '/',
    meta: {
      hidden: true,
    },
    component: loadView('views/layout/layout'),
    children: [
      {
        path: 'home',
        name: '主页',
        meta: {
          label: '主页',
          hidden: true,
        },
        component: loadView('views/home/home'),
      },
    ],
  },
]

function loadView(path) {
  return () => import(/* webpackChunkName: "chunk-[request][index]" */ `@/${path}`)
}
